import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { Button, Modal, Glyphicon, ControlLabel, FormControl } from 'react-bootstrap';

var AddListwa = React.createClass({

	getInitialState: function() {
		return {
			numerListwy: '',
			ilot: '',
			kawalki: [{ dlugoscCm: '', ilosc: '1' }]
		};
	},

	clearAddObject: function() {
		this.setState({
			numerListwy: '',
			ilot: '',
			kawalki: [{ dlugoscCm: '', ilosc: '1' }]
		});
	},

	onNumerChange: function(e) {
		this.setState({ numerListwy: e.target.value });
	},

	onIlotChange: function(e) {
		this.setState({ ilot: e.target.value });
	},

	onKawalekDlugoscChange: function(idx, e) {
		var val = e.target.value.replace(/,/g, '.');
		var kawalki = this.state.kawalki.slice();
		kawalki[idx] = Object.assign({}, kawalki[idx], { dlugoscCm: val });
		this.setState({ kawalki: kawalki });
	},

	onKawalekIloscChange: function(idx, e) {
		var val = e.target.value.replace(/[^0-9]/g, '');
		var kawalki = this.state.kawalki.slice();
		kawalki[idx] = Object.assign({}, kawalki[idx], { ilosc: val });
		this.setState({ kawalki: kawalki });
	},

	addKawalek: function() {
		var kawalki = this.state.kawalki.slice();
		kawalki.push({ dlugoscCm: '', ilosc: '1' });
		this.setState({ kawalki: kawalki });
	},

	removeKawalek: function(idx) {
		var kawalki = this.state.kawalki.slice();
		if (kawalki.length <= 1) return;
		kawalki.splice(idx, 1);
		this.setState({ kawalki: kawalki });
	},

	serializeKawalki: function() {
		var out = [];
		this.state.kawalki.forEach(function(k) {
			var dl = parseFloat(k.dlugoscCm);
			var il = parseInt(k.ilosc, 10);
			if (isNaN(dl) || dl <= 0) return;
			if (isNaN(il) || il <= 0) il = 1;
			for (var i = 0; i < il; i++) out.push(dl);
		});
		return out;
	},

	sumaCm: function() {
		return this.serializeKawalki().reduce(function(a, b) { return a + b; }, 0);
	},

	opisKawalkow: function() {
		// Grupowanie globalne: dwa wiersze z ta sama dlugoscia sumuja ilosci.
		var map = {};
		var order = [];
		this.state.kawalki.forEach(function(k) {
			var dl = parseFloat(k.dlugoscCm);
			var il = parseInt(k.ilosc, 10) || 1;
			if (isNaN(dl) || dl <= 0) return;
			var key = String(dl);
			if (map[key] === undefined) { map[key] = 0; order.push(dl); }
			map[key] += il;
		});
		return order.map(function(dl) {
			var ile = map[String(dl)];
			var m = (dl / 100);
			return ile > 1 ? (m + 'm × ' + ile) : (m + 'm');
		}).join(' + ');
	},

	render: function() {
		var self = this;
		var suma = this.sumaCm();
		var sumaM = (suma / 100).toFixed(2).replace(/\.?0+$/, '');
		var opis = this.opisKawalkow();

		return (
			<Modal show={this.props.parent.state.showAddModal}>
				<Modal.Header>
					<Modal.Title>Dodaj Listwę</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row" style={{ marginBottom: 10 }}>
						<div className="col-sm-4"><ControlLabel>Numer Listwy:</ControlLabel></div>
						<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Numer Listwy"
								value={this.state.numerListwy}
								onChange={this.onNumerChange} />
						</div>
					</div>

					<div className="row" style={{ marginBottom: 10 }}>
						<div className="col-sm-4"><ControlLabel>Ilot:</ControlLabel></div>
						<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Ilot"
								value={this.state.ilot}
								onChange={this.onIlotChange} />
						</div>
					</div>

					<hr />
					<div style={{ marginBottom: 8 }}><strong>Kawałki:</strong></div>

					{this.state.kawalki.map(function(k, idx) {
						return (
							<div key={idx} className="row" style={{ marginBottom: 6 }}>
								<div className="col-sm-5">
									<FormControl
										type="text"
										placeholder="długość cm"
										value={k.dlugoscCm}
										onChange={self.onKawalekDlugoscChange.bind(self, idx)} />
								</div>
								<div className="col-sm-1" style={{ paddingTop: 7, textAlign: 'center' }}>×</div>
								<div className="col-sm-3">
									<FormControl
										type="text"
										placeholder="szt"
										value={k.ilosc}
										onChange={self.onKawalekIloscChange.bind(self, idx)} />
								</div>
								<div className="col-sm-3">
									<Button
										bsStyle="danger"
										bsSize="small"
										disabled={self.state.kawalki.length <= 1}
										onClick={self.removeKawalek.bind(self, idx)}>
										<Glyphicon glyph="trash" />
									</Button>
								</div>
							</div>
						);
					})}

					<div style={{ marginTop: 8, marginBottom: 8 }}>
						<Button bsStyle="default" bsSize="small" onClick={this.addKawalek}>
							<Glyphicon glyph="plus" /> Dodaj kawałek
						</Button>
					</div>

					<div style={{ marginTop: 10, padding: 8, background: '#f5f5f5', borderRadius: 3 }}>
						<strong>Łącznie: {sumaM || '0'} m</strong>
						{opis ? <span style={{ marginLeft: 8, color: '#666' }}>({opis})</span> : null}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.props.parent.closeAddModal}>Zamknij</Button>
					<Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj</Button>
				</Modal.Footer>
			</Modal>
		);
	},

	onAddBtnClicked: function() {
		var parts = this.serializeKawalki();
		if (parts.length === 0) {
			alert('Dodaj przynajmniej jeden kawałek o długości > 0');
			return;
		}
		var payload = {
			numerListwy: this.state.numerListwy,
			ilot: this.state.ilot,
			kawalki: parts.join(','),
			iloscCm: parts.reduce(function(a, b) { return a + b; }, 0)
		};
		var self = this;
		axios.post(API_URL + '/stanListwy/', payload)
			.then(function() {
				self.props.parent.closeAddModal();
				self.props.parent.refreshTable();
			})
			.catch(function(error) {
				alert('Błędnie wprowadzone dane');
				console.log(error);
			});
	}
});

export default AddListwa;



// WEBPACK FOOTER //
// ./src/components/StanListwy/AddListwa.js